import { useMemo } from 'react'
import { type UseQueryResult } from '@tanstack/react-query'
import * as Prismic from '@prismicio/client'
import dayjs from 'dayjs'

import { usePrismic } from '@dhl/prismic'

import { type WhatsNewDocument } from '../model/types'

type Props = {
  url: string
  lang?: string
}

const query = Prismic.filter.at('document.type', 'whats_new')

export const usePrismicWhatsNewItems = ({
  url,
  lang = '',
}: Props): UseQueryResult<WhatsNewDocument[], Prismic.PrismicError<Response>> => {
  const options: Prismic.QueryParams = useMemo(
    () => ({
      orderings: [{ field: 'document.last_publication_date', direction: 'desc' }],
      lang,
    }),
    [lang]
  )
  return usePrismic<WhatsNewDocument, WhatsNewDocument[]>({ endpoint: url, query, options })
}

export const getDocumentDate = (document?: WhatsNewDocument): string =>
  document?.data?.date ? dayjs(document.data.date).toISOString() : ''
